/*
 * PokeSouq: pre-order goal guard (products tagged _goal), loaded deferred from layout/theme.liquid.
 * Markup: snippets/pokesouq-goal-terms.liquid (inside the product form, so quick view has it too).
 *
 * - Add to cart is blocked until the terms box is ticked, and always blocked when the goal
 *   metafields are missing (data-ps-goal-ready="false"). Enforced by a capture-phase submit
 *   guard that runs before the theme's product-form handler.
 * - A SOLD-OUT variant is never blocked, so Notify Me still opens on it. That is why the
 *   lock uses aria-disabled + a class rather than the disabled attribute: a disabled button
 *   can't open the notify popup, and product-info.js resets `disabled` on every variant change.
 * - The hidden properties (_goal_terms, _goal_terms_version, _goal_terms_at) are disabled -
 *   so not sent - until the box is ticked; _goal_terms_at is stamped at that moment (ISO).
 */
(function () {
  'use strict';

  function wrapperOf(el) { return el.closest('[data-form-wrapper]'); }

  function isSoldOut(form) {
    var w = wrapperOf(form);
    return !!(w && (w.classList.contains('variant--soldout') || w.classList.contains('variant--unavailable')));
  }

  function goalOf(form) { return form.querySelector('[data-ps-goal]'); }

  function agreed(goal) {
    var box = goal.querySelector('[data-ps-goal-box]');
    return goal.getAttribute('data-ps-goal-ready') === 'true' && !!box && box.checked;
  }

  function setProps(goal, on) {
    goal.querySelectorAll('[data-ps-goal-prop]').forEach(function (input) { input.disabled = !on; });
    if (on) {
      var at = goal.querySelector('[data-ps-goal-at]');
      if (at) at.value = new Date().toISOString();
    }
  }

  function refresh(form) {
    var goal = goalOf(form);
    if (!goal) return;
    var btn = form.querySelector('[data-add-to-cart]');
    if (!btn) return;
    var locked = !agreed(goal) && !isSoldOut(form);
    if (btn.classList.contains('ps-goal-locked') !== locked) btn.classList.toggle('ps-goal-locked', locked);
    if (locked && btn.getAttribute('aria-disabled') !== 'true') btn.setAttribute('aria-disabled', 'true');
    if (!locked && btn.hasAttribute('aria-disabled')) btn.removeAttribute('aria-disabled');
  }

  function refreshAll() {
    document.querySelectorAll('[data-ps-goal]').forEach(function (goal) {
      var form = goal.closest('form');
      if (form) refresh(form);
    });
  }

  // ticking / unticking the box
  document.addEventListener('change', function (e) {
    var box = e.target.closest && e.target.closest('[data-ps-goal-box]');
    if (!box) return;
    var goal = box.closest('[data-ps-goal]');
    setProps(goal, box.checked);
    var msg = goal.querySelector('[data-ps-goal-msg]');
    if (msg && box.checked) msg.hidden = true;
    var form = box.closest('form');
    if (form) refresh(form);
  });

  // the guard - capture phase, before the theme's product-form submit handler
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    var goal = goalOf(form);
    if (!goal) return;
    if (isSoldOut(form)) return;                 // let Notify Me work on sold-out variants
    if (agreed(goal)) { setProps(goal, true); return; }
    e.preventDefault();
    e.stopImmediatePropagation();
    var msg = goal.querySelector('[data-ps-goal-msg]');
    if (msg) msg.hidden = false;
  }, true);

  // keep the lock right after variant switches and when quick view loads
  var queued = false;
  function schedule() {
    if (queued || !document.querySelector('[data-ps-goal]')) return;   // nothing to do on most pages
    queued = true;
    (window.requestAnimationFrame || setTimeout)(function () { queued = false; refreshAll(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refreshAll);
  else refreshAll();
  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'disabled']
  });

  // exposed for the Node test harness only
  window.PokesouqGoal = { refreshAll: refreshAll, agreed: agreed, isSoldOut: isSoldOut };
})();
